import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoArrowBack, IoSave, IoFlash } from 'react-icons/io5';
import './CrearCargoScreen.css';
import './ConfiguraCuotasAutomaticasScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

function ConfiguraCuotasAutomaticasScreen() {
    const navigate = useNavigate();
    const { userData } = useAuth();

    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [active, setActive] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    // Config State
    const [diaGeneracion, setDiaGeneracion] = useState(1);
    const [diaVencimiento, setDiaVencimiento] = useState(10);
    const [monto, setMonto] = useState(0);
    const [tipo, setTipo] = useState('Cuota Ordinaria');
    const [conceptoTemplate, setConceptoTemplate] = useState('Mantenimiento {mes} {anio}');

    // Descuentos Prepago
    const [desc3Meses, setDesc3Meses] = useState(0);
    const [desc6Meses, setDesc6Meses] = useState(0);
    const [desc12Meses, setDesc12Meses] = useState(0);
    const [tipoDesc3Meses, setTipoDesc3Meses] = useState('percentage');
    const [tipoDesc6Meses, setTipoDesc6Meses] = useState('percentage');
    const [tipoDesc12Meses, setTipoDesc12Meses] = useState('percentage');

    useEffect(() => {
        if (!userData?.condominioId) return;

        const fetchConfig = async () => {
            try {
                const ref = doc(db, 'condominios', userData.condominioId, 'configuracion_cuotas', 'mensual');
                const snap = await getDoc(ref);
                if (snap.exists()) {
                    const data = snap.data();
                    setActive(data.active || false);
                    setDiaGeneracion(data.diaGeneracion || 1);
                    setDiaVencimiento(data.diaVencimiento || 10);
                    setMonto(data.monto || 0);
                    setTipo(data.tipo || 'Cuota Ordinaria');
                    setConceptoTemplate(data.conceptoTemplate || 'Mantenimiento {mes} {anio}');
                    setDesc3Meses(data.desc3Meses || 0);
                    setDesc6Meses(data.desc6Meses || 0);
                    setDesc12Meses(data.desc12Meses || 0);
                    setTipoDesc3Meses(data.tipoDesc3Meses || 'percentage');
                    setTipoDesc6Meses(data.tipoDesc6Meses || 'percentage');
                    setTipoDesc12Meses(data.tipoDesc12Meses || 'percentage');
                }
            } catch (e) {
                console.error("Error fetching config", e);
            } finally {
                setLoadingData(false);
            }
        };
        fetchConfig();
    }, [userData]);

    const handleSave = async (e) => {
        e.preventDefault();
        if (monto <= 0) {
            setAlertMessage({ type: 'error', text: "El monto debe ser mayor a 0" });
            return;
        }

        setLoading(true);
        try {
            const ref = doc(db, 'condominios', userData.condominioId, 'configuracion_cuotas', 'mensual');
            await setDoc(ref, {
                active,
                diaGeneracion: Number(diaGeneracion),
                diaVencimiento: Number(diaVencimiento),
                monto: Number(monto),
                tipo,
                conceptoTemplate,
                desc3Meses: Number(desc3Meses),
                desc6Meses: Number(desc6Meses),
                desc12Meses: Number(desc12Meses),
                tipoDesc3Meses,
                tipoDesc6Meses,
                tipoDesc12Meses,
                updatedAt: new Date()
            });

            // Sync with parent condominium document CRM proyecciones fields
            const condoRef = doc(db, 'condominios', userData.condominioId);
            await updateDoc(condoRef, {
                'proyecciones.cuotaEstimada': Number(monto),
                'proyecciones.diaGeneracion': Number(diaGeneracion),
                'proyecciones.diaVencimiento': Number(diaVencimiento),
                'proyecciones.autoGeneracionActiva': active
            });

            setAlertMessage({ type: 'success', text: "Configuración guardada exitosamente y sincronizada con el CRM." });
        } catch (e) {
            console.error("Error saving:", e);
            setAlertMessage({ type: 'error', text: "Error al guardar: " + e.message });
        } finally {
            setLoading(false);
        }
    };

    if (loadingData) {
        return (
            <div className="ks-page">
                <KondoSidebar activeRoute="/gestion-cuotas" />
                <main className="ks-main">
                    <div className="ks-header-sticky-wrapper">
                        <KondoBrandHeader showBack={false} />
                    </div>
                    <div className="ks-scroll-area" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                        <div style={{ color: '#6b7280' }}>Cargando configuración...</div>
                    </div>
                    <KondoBottomNav activeRoute="/gestion-cuotas" />
                </main>
            </div>
        );
    }

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/gestion-cuotas" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="automation-container">
                        <div className="muro-header-stitch" style={{ marginBottom: '25px' }}>
                            <div className="ac-hero" style={{ position: 'relative', display: 'flex', alignItems: 'center', minHeight: '120px', marginBottom: 0 }}>
                                <button
                                    type="button"
                                    onClick={() => navigate('/admin-cuotas/crear')}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        backdropFilter: 'blur(10px)',
                                        color: 'white',
                                        border: '1px solid rgba(255, 255, 255, 0.3)',
                                        padding: '8px',
                                        borderRadius: '50%',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '40px',
                                        height: '40px',
                                        transition: 'background 0.2s',
                                        marginRight: '15px',
                                        flexShrink: 0
                                    }}
                                    className="glass-back-btn"
                                >
                                    <IoArrowBack size={20} />
                                </button>
                                <div style={{ flex: 1, zIndex: 2 }}>
                                    <h1 style={{ margin: 0, fontSize: '1.6rem', color: 'white', fontWeight: 'bold' }}>Automatización de Cuotas</h1>
                                    <p style={{ margin: '5px 0 0 0', opacity: 0.9, color: 'white' }}>Define las reglas para la generación mensual automática.</p>
                                </div>
                                <IoFlash style={{ opacity: 0.15, fontSize: '80px', position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', color: 'white', zIndex: 1, pointerEvents: 'none' }} />
                            </div>
                        </div>

                        <div className="ac-info-card">
                            <IoFlash size={24} style={{ marginTop: '2px' }} />
                            <div>
                                <strong>Modo Automático:</strong> El sistema creará los cargos para <strong>todos los residentes</strong> activos (excepto admins) el día programado.
                            </div>
                        </div>

                        <form onSubmit={handleSave} className="ac-form">

                            <div className={`ac-toggle-group ${active ? 'active' : ''}`}>
                                <label style={{ fontWeight: 'bold', fontSize: '1.1em', cursor: 'pointer' }} onClick={() => setActive(!active)}>
                                    Activar Generación Automática
                                </label>
                                <label className="ac-switch">
                                    <input
                                        type="checkbox"
                                        checked={active}
                                        onChange={(e) => setActive(e.target.checked)}
                                    />
                                    <span className="ac-slider"></span>
                                </label>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                <div className="ac-input-group">
                                    <label>Día de Generación</label>
                                    <input
                                        type="number"
                                        min="1" max="28"
                                        value={diaGeneracion}
                                        onChange={e => setDiaGeneracion(e.target.value)}
                                        className="ac-input"
                                        required
                                    />
                                    <div className="ac-helper-text">Cuando se crearán los cargos.</div>
                                </div>

                                <div className="ac-input-group">
                                    <label>Día de Vencimiento</label>
                                    <input
                                        type="number"
                                        min="1" max="31"
                                        value={diaVencimiento}
                                        onChange={e => setDiaVencimiento(e.target.value)}
                                        className="ac-input"
                                        required
                                    />
                                    <div className="ac-helper-text">Día del mismo mes.</div>
                                </div>
                            </div>

                            <div className="ac-input-group">
                                <label>Tipo de Cuota</label>
                                <select value={tipo} onChange={e => setTipo(e.target.value)} className="ac-input" style={{ height: '46px' }}>
                                    <option value="Cuota Ordinaria">Cuota Ordinaria</option>
                                    <option value="Cuota Extraordinaria">Cuota Extraordinaria</option>
                                </select>
                            </div>

                            <div className="ac-input-group">
                                <label>Monto (MXN)</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={monto}
                                    onChange={e => setMonto(e.target.value)}
                                    className="ac-input"
                                    required
                                />
                            </div>

                            <div className="ac-input-group">
                                <label>Plantilla de Concepto</label>
                                <input
                                    type="text"
                                    value={conceptoTemplate}
                                    onChange={e => setConceptoTemplate(e.target.value)}
                                    className="ac-input"
                                    required
                                />
                                <div className="ac-helper-text">
                                    Variables: <span className="ac-code">{'{'}mes{'}'}</span>, <span className="ac-code">{'{'}anio{'}'}</span>.<br />
                                    Ejemplo: "Mantenimiento {'{'}mes{'}'} {'{'}anio{'}'}" &rarr; "Mantenimiento Enero 2026"
                                </div>
                            </div>
                            <div style={{ marginTop: '25px', padding: '15px', border: '1px solid #cbd5e1', borderRadius: '12px', background: '#f8fafc', marginBottom: '20px' }}>
                                <h3 style={{ margin: '0 0 10px 0', fontSize: '1rem', color: '#1e293b', fontWeight: '700' }}>Descuentos por Pago Adelantado (Prepago)</h3>
                                <p style={{ margin: '0 0 15px 0', fontSize: '0.8rem', color: '#64748b', lineHeight: '1.4' }}>
                                    Otorga un incentivo en porcentaje (%) o monto fijo ($) a los residentes que paguen de forma anticipada. El descuento corre a cargo del fraccionamiento.
                                </p>
                                <div className="prepay-discounts-grid">
                                    <div className="ac-input-group" style={{ marginBottom: 0 }}>
                                        <label style={{ fontSize: '0.8rem', display: 'block', marginBottom: '6px' }}>3 Meses</label>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <input
                                                type="number"
                                                min="0"
                                                value={desc3Meses}
                                                onChange={e => setDesc3Meses(Math.max(0, Number(e.target.value) || 0))}
                                                className="ac-input"
                                                style={{ flex: 1, height: '40px', padding: '8px' }}
                                            />
                                            <select 
                                                value={tipoDesc3Meses} 
                                                onChange={e => setTipoDesc3Meses(e.target.value)} 
                                                className="ac-input" 
                                                style={{ width: '65px', height: '40px', padding: '5px', fontSize: '0.9rem' }}
                                            >
                                                <option value="percentage">%</option>
                                                <option value="fixed">$</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="ac-input-group" style={{ marginBottom: 0 }}>
                                        <label style={{ fontSize: '0.8rem', display: 'block', marginBottom: '6px' }}>6 Meses</label>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <input
                                                type="number"
                                                min="0"
                                                value={desc6Meses}
                                                onChange={e => setDesc6Meses(Math.max(0, Number(e.target.value) || 0))}
                                                className="ac-input"
                                                style={{ flex: 1, height: '40px', padding: '8px' }}
                                            />
                                            <select 
                                                value={tipoDesc6Meses} 
                                                onChange={e => setTipoDesc6Meses(e.target.value)} 
                                                className="ac-input" 
                                                style={{ width: '65px', height: '40px', padding: '5px', fontSize: '0.9rem' }}
                                            >
                                                <option value="percentage">%</option>
                                                <option value="fixed">$</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="ac-input-group" style={{ marginBottom: 0 }}>
                                        <label style={{ fontSize: '0.8rem', display: 'block', marginBottom: '6px' }}>12 Meses</label>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <input
                                                type="number"
                                                min="0"
                                                value={desc12Meses}
                                                onChange={e => setDesc12Meses(Math.max(0, Number(e.target.value) || 0))}
                                                className="ac-input"
                                                style={{ flex: 1, height: '40px', padding: '8px' }}
                                            />
                                            <select 
                                                value={tipoDesc12Meses} 
                                                onChange={e => setTipoDesc12Meses(e.target.value)} 
                                                className="ac-input" 
                                                style={{ width: '65px', height: '40px', padding: '5px', fontSize: '0.9rem' }}
                                            >
                                                <option value="percentage">%</option>
                                                <option value="fixed">$</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button type="submit" className="cc-btn-primary" style={{ marginTop: '10px' }} disabled={loading}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                    <IoSave size={20} />
                                    {loading ? 'Guardando...' : 'Guardar Configuración'}
                                </div>
                            </button>

                        </form>
                    </div>
                </div>
                {alertMessage && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(15, 23, 42, 0.6)',
                        backdropFilter: 'blur(8px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999,
                        padding: '20px'
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '24px',
                            padding: '30px',
                            width: '100%',
                            maxWidth: '360px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                            textAlign: 'center',
                            border: '1px solid #f1f5f9'
                        }}>
                            <div style={{
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                backgroundColor: alertMessage.type === 'error' ? '#fef2f2' : '#ecfdf5',
                                color: alertMessage.type === 'error' ? '#ef4444' : '#10b981',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 20px auto',
                                fontSize: '24px'
                            }}>
                                {alertMessage.type === 'error' ? '⚠️' : '✓'}
                            </div>
                            <h3 style={{
                                margin: '0 0 8px 0',
                                fontSize: '1.25rem',
                                fontWeight: '800',
                                color: '#0f172a'
                            }}>
                                {alertMessage.type === 'error' ? 'Atención' : '¡Excelente!'}
                            </h3>
                            <p style={{
                                margin: '0 0 24px 0',
                                color: '#64748b',
                                fontSize: '0.9rem',
                                lineHeight: '1.5'
                            }}>
                                {alertMessage.text}
                            </p>
                            <button
                                onClick={() => setAlertMessage(null)}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '12px',
                                    background: alertMessage.type === 'error' ? '#ef4444' : '#10b981',
                                    color: 'white',
                                    fontWeight: '700',
                                    fontSize: '0.95rem',
                                    cursor: 'pointer',
                                    boxShadow: alertMessage.type === 'error' ? '0 4px 12px rgba(239, 68, 68, 0.2)' : '0 4px 12px rgba(16, 185, 129, 0.2)',
                                    transition: 'all 0.2s'
                                }}
                            >
                                Entendido
                            </button>
                        </div>
                    </div>
                )}
                <KondoBottomNav activeRoute="/gestion-cuotas" />
            </main>
        </div>
    );
}

export default ConfiguraCuotasAutomaticasScreen;
